import constants from '@core/utils/constants';

class PollingEngine {
  constructor() {
    this.tasks = new Map();
  }

  setup(bus) {
    bus.on('network.polling.start', ({ taskId, requestConfig, every }) => {
      console.log('Starting polling for', taskId, requestConfig);
      const interval = every ? parseInterval(every) : 30000;
      this.startPolling(taskId, requestConfig, interval);
    });

    bus.on('network.polling.stop', ({ taskId }) => {
      this.stopPolling(taskId);
    });
  }

  startPolling(taskId, requestConfig, interval = 30000) {
    if (this.tasks.has(taskId)) {
      console.log(`Polling déjà actif → ${taskId}`);
      return;
    }

    this.stopPolling(taskId);

    const poll = () => {
      const config = {
        ...requestConfig,
        id: `${taskId}-${Date.now()}`
      };
      window.$bus?.emit(constants.EVENTS.NETWORK.REQUEST, config);
    };

    poll();
    const timer = setInterval(poll, interval);

    const stop = () => {
      clearInterval(timer);
      this.tasks.delete(taskId);
      console.log(`Polling arrêté → ${taskId}`);
    };

    this.tasks.set(taskId, { stop, config: requestConfig, interval });
    console.log(`Polling démarré → ${taskId} toutes les ${interval / 1000}s`);
  }

  stopPolling(taskId) {
    const task = this.tasks.get(taskId);
    if (task) task.stop();
  }
}

function parseInterval(str) {
  const match = str.toString().match(/^(\d+)(s|m)?$/);
  if (!match) return 30000;
  const value = parseInt(match[1]);
  return match[2] === 'm' ? value * 60000 : value * 1000;
}

const pollingEngine = new PollingEngine();

export const setupPolling = pollingEngine.setup.bind(pollingEngine);
export default pollingEngine;
